import { Button, TableProps } from 'antd';
import React, { ReactElement } from 'react';

interface IControlPanelButton {
    icon: ReactElement;
    title?: string;
    type?: 'link' | 'text' | 'default' | 'primary' | 'dashed' | undefined;
    data?: TableProps['columns'];
    onClick?: () => void;
    loading?: boolean;
}

const ControlPanelButton: React.FC<IControlPanelButton> = ({ icon, title, type, loading, onClick }) => {
    const onClickButton = () => {
        if (onClick) {
            onClick();
        }
    };
    return (
        <Button icon={icon} loading={loading} type={type} onClick={onClickButton}>
            {title && title}
        </Button>
    );
};

export default ControlPanelButton;
